import { useEffect } from 'react'
import * as S from './styles'

//images
import dados from '../../../assets/images/dados-protegidos.png'
import reclameaqui from '../../../assets/images/reclameaqui.png'
import safebrowsing from '../../../assets/images/safebrowsing-logo.svg'

//utils
import { paymentMethods, UlteisList } from '../../utils/footer'
import { Container } from '../../styles'

function Footer() {

	/** Reclame aqui - tentativa de script 
	useEffect(() => {
		const divReclame = document.createElement('div');
		divReclame.setAttribute('id', 'ra-verified-seal');

		const script = document.createElement('script');
	  
		script.src = "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js";
		script.setAttribute('data-id', 'cmFQWWJrbmZEdGVRdkFVUTpvLWFudGFnb25pc3R');
		script.setAttribute('data-target', 'ra-verified-seal');
		script.setAttribute('data-model','2');
		script.setAttribute('id', 'ra-embed-verified-seal');

		divReclame.appendChild(script);
		
		const reclameAqui = document.getElementById('reclameAqui');
		if(reclameAqui){
				reclameAqui.appendChild(divReclame);
			return () => {
				reclameAqui.removeChild(divReclame);
			}
		}
	  }, []);*/

	const actualYear = new Date().getFullYear();

	return (
		<S.Container>
			<Container>
				<S.HelpContainer>
					<S.HelpSection>
						<S.HelpTitle>Central de Ajuda ao Assinante</S.HelpTitle>
						<S.SecurityContainer>
							<div id="reclameAqui">
								<a href="https://www.reclameaqui.com.br/empresa/o-antagonista/?utm_source=referral&utm_medium=embbed&utm_campaign=ra_verificada&utm_term=horizontal" target="_blank">
									<img src={reclameaqui} />
								</a>
							</div>
							<div id="ra-verified-seal"><script type="text/javascript" id="ra-embed-verified-seal" src="https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js" data-id="cmFQWWJrbmZEdGVRdkFVUTpvLWFudGFnb25pc3Rh" data-target="ra-verified-seal" data-model="2"></script></div>
						</S.SecurityContainer>
					</S.HelpSection>
					<S.HelpSection>
						<S.NeedHelpText>Precisa de ajuda?</S.NeedHelpText>
						<S.HelpParagraph02>
							Você pode entrar em contato conosco pelo e-mail
							<S.Link href='mailto:assinante@oantagonista.com'>
								assinante@oantagonista.com
							</S.Link>
						</S.HelpParagraph02>
					</S.HelpSection>
				</S.HelpContainer>

				<S.Hr />

				<S.InfosContainer>
					<S.InfosSection>
						<S.InfosTitle>Úteis</S.InfosTitle>
						{UlteisList.map(({ title, link }) => (
							<S.Utils href={link} key={title}>
								{title}
							</S.Utils>
						))}
					</S.InfosSection>

					<S.InfosSection>
						<S.InfosTitle>Formas de Pagamento</S.InfosTitle>
						<S.PaymentsContainer>
							{paymentMethods.map((image) => (
								<S.PaymentMethod src={image} key={image} />
							))}
						</S.PaymentsContainer>
					</S.InfosSection>

					<S.InfosSection>
						<S.InfosTitle>Segurança</S.InfosTitle>
						<S.SecurityContainer>
							<S.SecurityItem src={safebrowsing} />
							<div style={{ marginTop: '30px' }}></div>
							<S.SecurityItem src={dados} />
						</S.SecurityContainer>
					</S.InfosSection>
				</S.InfosContainer>

				<S.Hr />
				<S.CopyrightContainer>
					<S.HelpSimpleText>
						O Antagonista & Crusoé {actualYear} © Todos os direitos reservados
					</S.HelpSimpleText>

					<div>
						<S.FooterText>
							MARE CLAUSUM PUBLICAÇÕES LTDA. - CNPJ 25.163.879/0001-13
						</S.FooterText>
					</div>
				</S.CopyrightContainer>
			</Container>
		</S.Container>
	)
}

export { Footer }
